import {
  loggedIn,
  userSignedUp,
  userEmailVerified,
  userApproved,
  userNotActive,
} from '../../../routes/conditional';
import { activateUserChain, fetchUser } from '../../../redux/modules/user';
import paths from '../../../routes/paths';

export const page = {
  path: paths.signup.consent,
  isAllowed: [
    loggedIn,
    userSignedUp,
    userEmailVerified,
    userApproved,
    userNotActive,
  ],
  action: () => fetchUser(),
};

export const activateAccount = {
  actionPath: '/actions/signup/activate-account',
  action: () => activateUserChain(),
};

export const clearActivationError = {
  actionPath: '/actions/signup/clear-activation-error',
  action: () => clearActivationError(),
};
